import {checkIfRankSkinNewArtReady, RANK_SKIN_OLD_ART_LEAGUES} from '../../configs/rankSkins';
import {getFactionImagePath} from './getFactionImagePath';

export const getFactionRankImagePath = (factionId, rank) => {
  if (!factionId || !rank) {
    return '/img/other/strategikon_bust.png';
  }
  // Новый арт образа — в ranks_new; лиги без него пока на прежнем арте
  if (checkIfRankSkinNewArtReady(rank, factionId)) {
    return `/img/factions/ranks_new/${factionId}_${rank}.jpg`;
  }
  if (RANK_SKIN_OLD_ART_LEAGUES.includes(rank)) {
    return `/img/factions/ranks/${factionId}_${rank}.jpg`;
  }
  // Арта нет ни нового, ни прежнего (алмазный образ фракции, для которой его
  // еще не нарисовали, — такой можно получить только выдачей вручную):
  // показываем обычный вид фракции, рамка лиги ляжет поверх
  return getFactionImagePath(factionId);
};
